export default __webpack_public_path__ + "static/club-voyages-banner-ef2c1d72c494627f99fb09c3d6d42083.webp";